import { helpers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as selector from './tools.js'
import { list, close } from '#utilities/js/lightboxes/menus/menu.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { value } = button
    const container = closest(`.${helpers.dateSelector.elements.container}`, button)
    const { dataset } = container
    const { view } = dataset
    const dateToday = new Date(value * 86400 * 1000)
    const menu = list(button)

    selector.setTargetValue(container, value)

    if (view === 'months' || view === 'years') {
      selector.toggleView(container, 'years')
    }

    selector.setDays(container, dateToday)

    if (menu) {
      close()
    }
  }
})

export default button => {
  onClick.listen(button)
}
